export default {
  methods: {
    onlyInt (e) {
      if (!e.key.replace(/\D/g, '') || !e) e.preventDefault()
    }
  }
}
